import { render, staticRenderFns } from "./studentWorks.vue?vue&type=template&id=f646b4e4&scoped=true"
import script from "./studentWorks.vue?vue&type=script&lang=js"
export * from "./studentWorks.vue?vue&type=script&lang=js"
import style0 from "./studentWorks.vue?vue&type=style&index=0&id=f646b4e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f646b4e4",
  null
  
)

export default component.exports